import { useState } from 'react';

const useLocalStorage = (key: string, defaultValue?: any) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = window.localStorage.getItem(key);
      if (value) return JSON.parse(value);
      else {
        window.localStorage.setItem(key, JSON.stringify(defaultValue));
      }
    } catch (err) {}
  });

  const setValue = (value: any) => {
    window.localStorage.setItem(key, JSON.stringify(value));
    setStoredValue(value);
  };

  const clearValue = () => {
    window.localStorage.removeItem(key);
  };

  return [storedValue, setValue, clearValue];
};

export { useLocalStorage };
